import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/authContext';
import { Spin } from 'pink-lava-ui';
import { api } from '@dc-trans/data-layer';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, logout, isLogoutManually } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      response => response,
      error => {
        const isRefreshRequest = error.config?.url?.includes('auth/refresh');
        const isInvalidTokenMessage = error.response?.data?.message === 'Invalid or expired token';

        // Logout if:
        // 1. The 401 is from a failed refresh attempt
        // 2. The 401 is NOT "Invalid or expired token" (meaning unrecoverable auth error)
        if (error.response?.status === 401 && (isRefreshRequest || !isInvalidTokenMessage)) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(interceptor);
    };
  }, [logout]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size={'large'} />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('masuk protected route', { isLogoutManually });
    // Capture the current path including search params for redirect after login
    const redirectTo = location.pathname + location.search;
    const loginUrl = !isLogoutManually ? `/login?redirect_to=${encodeURIComponent(redirectTo)}` : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
